import IMapPointAdapter from '../IMapPointAdapter'

export default class GoogleMapPointAdapter implements IMapPointAdapter {
    private map: google.maps.Map

    constructor(map: google.maps.Map) {
        this.map = map
    }

    public set(marker: google.maps.Marker & {infoWindowRef: {setup: Function , callback: Function}}, clusterExpansionZoom: number, isCluster: boolean) {
        marker.setMap(this.map)
        if (isCluster) marker.addListener('click', () => this.onZoom(marker, clusterExpansionZoom))
        else {

            let clickTimer: number | null = null
            const clickDelay = 500 // Delay in milliseconds
            
            marker.addListener('click', () => {
                if (!clickTimer) {
                    clickTimer = window.setTimeout(() => {
                        const popup = marker.infoWindowRef?.setup()
                        marker.infoWindowRef?.callback(popup)
                        clickTimer = null
                    }, clickDelay)
                }
            })

            marker.addListener('dblclick', () => {
                window.clearTimeout(clickTimer)
                clickTimer = null
                this.onZoom(marker, clusterExpansionZoom)
            })
        }
    }

    public hide(marker: google.maps.Marker) {
        marker.setVisible(false)
    }

    public show(marker: google.maps.Marker) {
        marker.setVisible(true)
    }

    public findInBbox(marker: google.maps.Marker): boolean {
        const bounds = this.map.getBounds()
        return bounds.contains(marker.getPosition())
    }

    public delete(marker: google.maps.Marker) {
        marker.setMap(null)
        google.maps.event.clearInstanceListeners(marker)
    }

    public addListener(type: string, callback: Function): void {
        this.map.addListener(type, callback)
    }

    public center(lat, lng) {
        this.map.setCenter({ lat, lng })
    }

    // FIX ME: Check max zoom
    private onZoom(marker: google.maps.Marker, clusterExpansionZoom: number) {
        const position = marker.getPosition()
        this.center(position.lat(), position.lng())
        this.map.setZoom(clusterExpansionZoom)
        // if (cluster.clusterExpansionZoom <= this.maxZoom) this.map.setZoom(cluster.clusterExpansionZoom)
    }

    public getZoom(): number {
        return this.map.getZoom()
    }
}
